module.exports = __webpack_public_path__ + "img/our-mission1.a53c633d.png";